import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Contact() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section id="contact" className="py-14 md:py-20 bg-foreground-950 text-background-50">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10">
        <div
          ref={ref}
          className={`max-w-2xl mx-auto text-center transition-all duration-1000 ${revealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          {/* Label */}
          <div className="flex items-center justify-center gap-2 mb-5">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500" />
            <span className="font-label text-[10px] tracking-[0.12em] uppercase text-background-400">
              Contact
            </span>
          </div>

          {/* Heading — English title */}
          <p className="font-heading font-bold text-[clamp(18px,2.4vw,28px)] leading-tight tracking-[-0.03em] mb-3">
            Open to new <span className="text-primary-500">opportunities.</span>
          </p>

          {/* Statement — Japanese text (kept as-is, compact) */}
          <p className="text-background-300 text-sm leading-relaxed mb-10 max-w-lg mx-auto">
            ブランド戦略・CXプランニング・サービスデザイン・ビジネスデザインを軸に、事業課題の整理から価値定義、体験・コミュニケーション設計、クリエイティブ実装まで一貫して取り組んできました。領域横断の経験を活かし、チームとともに戦略とクリエイティブをつなぎ、新たな事業価値と顧客体験を生み出していきたいと考えています。
          </p>

          {/* Contact info — minimal, horizontal */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-10">
            <a
              href="mailto:bananagraphysm@gmail.com"
              className="group flex items-center gap-2.5 text-sm hover:text-primary-500 transition-colors"
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full border border-background-50/20 group-hover:border-primary-500 transition-colors">
                <i className="ri-mail-line text-sm" />
              </span>
              <span>bananagraphysm@gmail.com</span>
            </a>

            <span className="hidden sm:block w-px h-4 bg-background-50/20" />

            <span className="flex items-center gap-2.5 text-sm text-background-400">
              <span className="w-8 h-8 flex items-center justify-center rounded-full border border-background-50/20">
                <i className="ri-map-pin-line text-sm" />
              </span>
              <span>Tokyo, Japan</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}